var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sonsFlexEvent"},[_c('div',{staticClass:"flexList"},[_vm._m(0),_c('div',{staticClass:"Content"},[_c('Table',{attrs:{"columns":_vm.ContentListColumns,"data":_vm.upDataListNumber,"loading":_vm.loading}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexListTop"},[_c('p',[_vm._v("充值申请记录")])])
}]

export { render, staticRenderFns }